export default __webpack_public_path__ + "static/media/AF1.0b9034e5.jpg";